import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const RefundPage = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Back Button */}
      <div className="container mx-auto px-6 pt-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Back to Home</span>
        </Link>
      </div>

      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '60px 20px', background: '#000', color: '#fff' }}>
        
        <h1 style={{ fontSize: '48px', color: '#00d4ff', textAlign: 'center', marginBottom: '30px', textTransform: 'uppercase', letterSpacing: '3px' }}>
          Refund & Returns Policy
        </h1>
        
        <p style={{ fontSize: '14px', color: '#888', textAlign: 'center', marginBottom: '50px' }}>
          Last Updated: April 10, 2026
        </p>
        
        <div style={{ fontSize: '16px', color: '#ccc', lineHeight: '1.9' }}>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>1. Our Commitment to You</h2>
          <p>At EFAM, we stand behind the quality of our products. We want you to be completely satisfied with your purchase. This policy explains your rights and our procedures for returns, refunds, and exchanges under Australian Consumer Law.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>2. Australian Consumer Law Rights</h2>
          <p>Our products come with guarantees that cannot be excluded under the Australian Consumer Law. You are entitled to:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>A replacement or refund for a <strong>major failure</strong></li>
            <li>Compensation for any other reasonably foreseeable loss or damage</li>
            <li>Products repaired or replaced if they fail to be of <strong>acceptable quality</strong></li>
          </ul>
          <p><strong>Major Failure</strong> includes when the product:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Has a problem that would have stopped someone from buying it if they had known about it</li>
            <li>Is significantly different from the description or sample</li>
            <li>Is substantially unfit for its common purpose and cannot be easily fixed within a reasonable time</li>
            <li>Does not do what we said it would, or what you asked for, and cannot be easily fixed within a reasonable time</li>
            <li>Is unsafe</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>3. 30-Day Satisfaction Guarantee</h2>
          <p>We offer a <strong>30-day satisfaction guarantee</strong> on all EFAM products purchased directly from our website.</p>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>3.1 Eligibility</h3>
          <p>You may return your product within 30 days of delivery if:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>The product is in original condition with all accessories and packaging</li>
            <li>The product has not been damaged due to misuse or negligence</li>
            <li>You provide proof of purchase (order confirmation or receipt)</li>
            <li>You notify us within 30 days of delivery</li>
          </ul>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>3.2 Return Process</h3>
          <ol style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Contact Us:</strong> Reach out via our Contact page with your order number and reason for return</li>
            <li><strong>Return Authorization:</strong> We will provide return instructions and authorization within 2 business days</li>
            <li><strong>Ship the Product:</strong> Package securely and ship to the address provided (return shipping costs below)</li>
            <li><strong>Inspection:</strong> We will inspect the returned product within 5 business days of receipt</li>
            <li><strong>Refund:</strong> If approved, refund will be processed to your original payment method within 7 business days</li>
          </ol>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>4. Return Shipping Costs</h2>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>4.1 Change of Mind Returns</h3>
          <p>If you change your mind and the product is not faulty:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Customer pays</strong> return shipping costs</li>
            <li>Delivery is included in the displayed product price, so there is no separately itemised original shipping fee</li>
            <li>Any permitted deduction for reasonable outbound delivery costs will be disclosed before a change-of-mind return is authorised</li>
          </ul>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>4.2 Faulty or Incorrect Products</h3>
          <p>If the product is faulty, damaged, or we sent the wrong item:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>EFAM pays</strong> all return shipping costs</li>
            <li>Full refund including original shipping fees</li>
            <li>We will arrange pickup or provide prepaid return shipping label</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>5. Refund Methods and Timeframes</h2>
          <p><strong>Refund Method:</strong> All refunds are processed to your original payment method (credit/debit card via Stripe)</p>
          <p><strong>Timeframes:</strong></p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Inspection:</strong> Within 5 business days of receiving returned product</li>
            <li><strong>Refund Processing:</strong> Within 7 business days after approval</li>
            <li><strong>Bank Processing:</strong> Your bank may take 3-5 additional business days to show the refund</li>
          </ul>
          <p><strong>Total Timeframe:</strong> Expect full refund within 10-17 business days from when we receive your return</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>6. Exchanges</h2>
          <p>We do not offer direct exchanges. If you wish to exchange for a different model:</p>
          <ol style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Return the original product following the return process above</li>
            <li>Once refund is processed, place a new order for the desired model</li>
          </ol>
          <p><strong>Exception:</strong> If we shipped the wrong product, we will expedite the exchange at no cost to you.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>7. Non-Returnable Items</h2>
          <p>The following items <strong>cannot be returned</strong>:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Products damaged due to misuse, abuse, or unauthorized modifications</li>
            <li>Products missing original packaging, accessories, or manuals</li>
            <li>Products purchased from third-party retailers (contact the retailer directly)</li>
            <li>Clearance or final sale items (clearly marked as such)</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>8. Damaged or Defective Products</h2>
          <p>If your product arrives damaged or develops a defect:</p>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>8.1 Arrival Damage</h3>
          <p>If the product is visibly damaged upon delivery:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Document the damage with photos immediately</li>
            <li>Note the damage on the delivery receipt if possible</li>
            <li>Contact us within 48 hours with photos and order number</li>
            <li>We will arrange replacement or full refund at no cost to you</li>
          </ul>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>8.2 Manufacturing Defects</h3>
          <p>If a defect appears during normal use:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Contact us with description of the issue</li>
            <li>We may request photos or videos to assess the problem</li>
            <li>We will determine if repair, replacement, or refund is appropriate</li>
            <li>All shipping costs covered by EFAM for warranty claims</li>
          </ul>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>9. Warranty Coverage</h2>
          <p>All EFAM products include manufacturer warranty (specific terms provided with product). Warranty covers:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Manufacturing defects in materials and workmanship</li>
            <li>Component failures under normal use</li>
            <li>Parts and labor for covered repairs</li>
          </ul>
          <p>See your product manual for specific warranty duration and terms.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>10. Cancellations</h2>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>10.1 Before Shipment</h3>
          <p>You may cancel your order for a full refund if:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>The order has not yet shipped</li>
            <li>You contact us within 24 hours of placing the order</li>
          </ul>
          <p>Contact us immediately via our Contact page to cancel.</p>
          
          <h3 style={{ color: '#fff', fontSize: '20px', margin: '30px 0 15px' }}>10.2 After Shipment</h3>
          <p>Once shipped, cancellation is not available. You must follow the return process once you receive the product.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>11. Restocking Fees</h2>
          <p>EFAM does <strong>not charge restocking fees</strong> for returns within our 30-day satisfaction guarantee period, provided the product meets return eligibility requirements.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>12. Refund for Shipping Delays</h2>
          <p>Shipping timeframes are estimates:</p>
          <ul style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li><strong>Express Worldwide (included in price):</strong> 2-4 weeks</li>
          </ul>
          <p>These timeframes are <strong>estimates only</strong>. Customs, carriers and events outside EFAM's control may cause delays. Contact EFAM if delivery materially exceeds the estimate so we can investigate and explain the available remedy. Nothing in this policy limits rights that cannot be excluded under the Australian Consumer Law.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>13. Contact Us for Returns</h2>
          <p>To initiate a return or if you have questions about our refund policy, contact us at:</p>
          <p style={{ marginTop: '10px' }}><strong>Email:</strong> efamfitness@gmail.com<br />
          <strong>Phone:</strong> 0490 792 050 (9am-5pm)</p>
          <p style={{ marginTop: '10px' }}>Please include your order number and detailed description of the issue for fastest processing.</p>
          
          <h2 style={{ color: '#00d4ff', fontSize: '24px', margin: '40px 0 20px' }}>14. Dispute Resolution</h2>
          <p>If you have a concern about a return or refund:</p>
          <ol style={{ paddingLeft: '20px', margin: '15px 0' }}>
            <li>Contact us first - we will work with you to resolve the issue</li>
            <li>If unresolved, you may contact Fair Trading in your state</li>
            <li>For payment disputes, you may contact your card issuer or Stripe</li>
          </ol>
          
          <p style={{ marginTop: '40px', padding: '20px', background: 'rgba(0,212,255,0.05)', borderRadius: '10px', borderLeft: '4px solid #00d4ff' }}>
            <strong>We're here to help.</strong> If you have any concerns about your purchase, please reach out. We're committed to making things right.
          </p>
          
        </div>
        
      </div>
    </div>
  );
};

export default RefundPage;
